import { render, staticRenderFns } from "./DeviceInfoAdequacao.vue?vue&type=template&id=c0048e90&"
import script from "./DeviceInfoAdequacao.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoAdequacao.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoAdequacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports